module.exports = __webpack_public_path__ + "static/media/soviet_truck_120.05f410b8.png";